'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M64 192h896v128h-896v-128z' }),
        React.createElement('path', { d: 'M64 448h896v128h-896v-128z' }),
        React.createElement('path', { d: 'M64 704h896v128h-896v-128z' })
    ));
};